<h6>Customer: <span *ngIf="customer">{{ customer.name }}</span></h6>
<h6>Site: <a (click)="navigateToSiteComponent()" class="text-primary" *ngIf="site">{{ site.url }}</a></h6>
<h6>Page: <span *ngIf="page">{{ page.path }}</span></h6>
<br>
<div class="col-md-12 date-picker-score-accumulator-wrapper">
    <app-review-date-picker [datePickerMode]="DatePickerModeEnum.Month" (dateSelected)="onDateSelected($event)"></app-review-date-picker>
    <app-average-score-accumulators (averageScoreAccumulatorSelected)="onAverageScoreAccumulatorSelected($event)"></app-average-score-accumulators>
</div>
<app-page-review-scores-chart
        *ngFor="let sitePageChartData of sitePagesChartData"
        [pageChartData]="sitePageChartData">
</app-page-review-scores-chart>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/page/page.component.html